// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__RPCEO","content":"styles_content__w-AjO","title":"styles_title__AdtK4","item":"styles_item__vqxyW","row":"styles_row__U7oUT"};